export default "__VITE_ASSET__jV1H2XKy__"